<template>
    <div>
        <SalesReportFilters @loadReportClicked="loadReport($event)"></SalesReportFilters>
        <b-table
                :fields="unitsFields"
                :items="unitsTableData"
                class="pointer"
                striped
                hover
        />
        <b-table
                :current-page="currentPage"
                :fields="reportFields"
                :items="sales"
                :foot-clone="true"
                class="pointer"
                striped
                hover
                sort-by.sync="units"
                sort-desc.sync="false"
        />
    </div>
</template>

<script>
    import SalesReportFilters from '@/components/SalesReport/SalesReportFilters.vue';
    import { extractData, extractLinks } from '@/libs/backend/apimapper';

    export default {
        name: "SalesReportList",
        components: {
            SalesReportFilters,
        },
        data() {
            return {
                currentPage: 1,
                loading: false,
                sales: [],
                meta: null,
                unitsTableData: [
                        {
                            unitsTotal: 0,
                            negativeUnitsTotal: 0,
                            positiveUnitsTotal: 0,
                        },
                ],
                reportFields: [
                    {
                        key: 'SKU',
                        label: 'SKU',
                        sortable: true,
                    },
                    {
                        key: 'title',
                        label: 'Title',
                        sortable: true,
                    },
                    {
                        key: 'units',
                        label: 'Units',
                        sortable: true,
                    },
                    {
                        key: 'developerProceeds',
                        label: 'Dev Proceeds',
                        sortable: true,
                    },
                    {
                        key: 'beginDate',
                        label: 'Starts',
                        sortable: true,
                    },
                    {
                        key: 'endDate',
                        label: 'Ends',
                        sortable: true,
                    },
                    {
                        key: 'countryCode',
                        label: 'Country',
                        sortable: true,
                    },
                    {
                        key: 'subscription',
                        label: 'Subscription',
                        sortable: true,
                    },
                    {
                        key: 'period',
                        label: 'Period',
                        sortable: true,
                    },
                    {
                        key: 'device',
                        label: 'Device',
                        sortable: true,
                    },
                ],
                unitsFields: [
                    {
                        key: 'negativeUnitsTotal',
                        label: 'Negative Units Total',
                    },
                    {
                        key: 'positiveUnitsTotal',
                        label: 'Positive Units Total',
                    },
                    {
                        key: 'unitsTotal',
                        label: 'Units Total',
                    },
                ]
            }
        },
        computed: {
            totalRows() {
                return this.meta;
            },
        },
        methods: {
            async loadReport(event) {
                const sales = await this.$store.dispatch('backendTalker', {
                        request: 'sales_report',
                        query: this.buildQueryValue(event.date, event.app),
                    });

                this.sales = this.filterDataBySubscriptions(this.filterDataByTariffs(sales.data, event.tariffs), event.subs);
                this.meta = extractLinks(sales.data);

                this.computePositiveUnitsTotal();
                this.computeNegativeUnitsTotal();
                this.computeUnitsTotal();
            },

            filterDataByTariffs(data, tariffs) {
                if(tariffs && tariffs.length > 0 && data && data.length > 0)
                    return data.filter(el => tariffs.includes(el.SKU));
                return data;
            },

            filterDataBySubscriptions(data, subs) {
                if(subs && subs.length > 0 && data && data.length > 0)
                    return data.filter(el => subs.includes(el.subscription));
                return data;
            },

            buildQueryValue(date, app) {
                const searchParams = {
                    date_end: date,
                    apple_application_credentials: app,
                };

                const query = new URLSearchParams();
                Object.entries(searchParams).forEach(([key, value]) => query.append(key, value))
                return '?' + query.toString();
            },

            computeUnitsTotal() {
                this.unitsTableData[0].unitsTotal = this.unitsTableData[0].positiveUnitsTotal + this.unitsTableData[0].negativeUnitsTotal;
            },

            computeNegativeUnitsTotal() {
                this.unitsTableData[0].negativeUnitsTotal = this.sales
                    .map(a => a.units)
                    .filter(a => a < 0)
                    .reduce((a, b) => a + b, 0);
            },

            computePositiveUnitsTotal() {
                this.unitsTableData[0].positiveUnitsTotal = this.sales
                    .map(a => a.units)
                    .filter(a => a > 0)
                    .reduce((a, b) => a + b, 0);
            },
        },
    }
</script>

<style scoped>

</style>